module.exports = ".mat-slider-horizontal {\r\n  width: 500px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2128-upload-setting/upload-setting.component.css
// module id = ./src/app/a2128-upload-setting/upload-setting.component.css
// module chunks = main